/**
 * Theme entry point.
 *
 * Public surface:
 *   - `AppThemeProvider` — installs the MUI theme and the CSS custom properties.
 *   - `createAppTheme(brand)` — build a MUI theme from design tokens.
 *   - `BRANDS`, `BRAND_KEYS`, `getTokens` — the underlying design tokens.
 *   - `rsmTheme` — the default brand's MUI theme, kept for backward
 *     compatibility with any code that imported it directly.
 */
export { AppThemeProvider } from './AppThemeProvider';
export {
  BRAND_KEYS,
  BRANDS,
  DEFAULT_BRAND,
  DEFAULT_MODE,
  getTokens,
} from './brands';
export { createAppTheme } from './createAppTheme';
export { applyCssVars } from './cssVars';

import { DEFAULT_BRAND } from './brands';
import { createAppTheme } from './createAppTheme';

/** Default (EllaFin dark) theme — backward-compatible export. */
export const rsmTheme = createAppTheme(DEFAULT_BRAND);
